/**
 * Rounds a number to a specified number of decimal places.
 *
 * @example
 * // Returns 3.14
 * roundDecimals(3.14159, 2);
 *
 * @example
 * // Returns 3.142
 * roundDecimals(3.14159, 3);
 */
const roundDecimals = (number: number, decimals = 2): number => {
  const factor = 10 ** decimals;

  return Math.round((number + Number.EPSILON) * factor) / factor;
};

export default roundDecimals;
